import { trigger, state, style, transition, animate } from '@angular/animations';

const ANIMATION_TIMING = '200ms cubic-bezier(0.4,0.0,0.2,1)';

export const cardAnimations = {
  bodyExpansion: trigger('bodyExpansion', [
    state('collapsed', style({ height: '0px', visibility: 'hidden' })),
    state('expanded', style({ height: '*', visibility: 'visible' })),
    transition('expanded => collapsed', animate(0)),
    transition('collapsed => expanded', animate(0)),
  ]),

  iconRotation: trigger('iconRotate', [
    state('expanded', style({ transform: 'rotate(0)' })),
    transition('expanded <=> collapsed', animate(ANIMATION_TIMING)),
  ]),
};
